import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon';
import { Dropdown2WrapperComponent } from './dropdown-wrapper/dropdown-wrapper.component';
import { Dropdown2MenuComponent } from './dropdown-menu/dropdown-menu.component';
import { Dropdown2MenuCheckboxComponent } from './dropdown-menu-checkbox/dropdown-menu-checkbox.component';
import { Dropdown2HeaderComponent } from './dropdown-header/dropdown-header.component';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  exports: [
    Dropdown2WrapperComponent,
    Dropdown2MenuComponent,
    Dropdown2MenuCheckboxComponent,
    Dropdown2HeaderComponent
  ],
  declarations: [
    Dropdown2WrapperComponent,
    Dropdown2MenuComponent,
    Dropdown2MenuCheckboxComponent,
    Dropdown2HeaderComponent
  ]
})
export class Dropdown2Module { }
